//Lenis ===========
let lenis = null;
let breakpoint = 750;
let rafId = null;

function initializeLenis() {
  if (window.innerWidth >= breakpoint && !lenis) {
    lenis = new Lenis({
      // Lenisの設定
    });
    function raf(time) {
      if (lenis) {
        lenis.raf(time);
      }
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
  }
}

function destroyLenis() {
  if (lenis) {
    lenis.destroy();
    lenis = null;
  }
  if (rafId != null) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
}

// ウィンドウのリサイズ時にもLenisのインスタンスを再初期化
window.addEventListener('resize', function() {
  if (window.innerWidth >= breakpoint) {
    initializeLenis();
  } else {
    destroyLenis();
  }
});

// 初期化
initializeLenis();
